import styled from "styled-components";
import { styled as MuiStyled, TextField } from "@mui/material";

interface WrapperProps {
  wrapperCss?: string;
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  ${(props) => props.wrapperCss || ""}
`;

export const Title = styled.div`
  padding: 0 0 4px;
  line-height: 1.5;
  font-size: 16px;
  font-weight: 500;
  color: #333;
`;

export const StyledTextField = MuiStyled(TextField)({
  "& .MuiInputBase-root": {
    borderRadius: 10,
    backgroundColor: "white",
    paddingRight: 4,
    "& .MuiInputBase-input": {
      paddingLeft: 15,
      paddingRight: 5,
      paddingTop: 10,
      paddingBottom: 10,
    },
    "& .MuiInputAdornment-root": {
      marginLeft: 0,
      marginRight: 0,
      "& .MuiIconButton-root": {
        padding: 8,
        paddingLeft: 4,
      },
    },
  },
  "& label.Mui-focused": {
    color: "#fd954f",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#fd954f",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#e0e0e0",
    },
    "&:hover fieldset": {
      borderColor: "#fd954f",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#fd954f",
      borderWidth: 2,
    },
  },
});
